import React, { useContext } from 'react'
import '../../../styles/comedyStoriesSerials.css'
import  SectionSmall from '../comedyHome/sectionSmall'
import { Helmet } from 'react-helmet-async'
import { DeviceContext } from '..'
import PageAds from '../../common/pageAds'

const ComedyStoriesSerials = ({data}) => {


             const  ssrData = data?.[0]?.storiesSerialsPage || {};
             const {mobile,setMobile,containerRef} = useContext(DeviceContext)
          


    return (
        <div className='container-fluid comedy-storyserials-container'>
           <Helmet><title>Telugu Comedy | Telugu Jokes | Telugu Comedy Stories | Telugu Cartoon Jokes | Telugu comedy videos</title></Helmet>
            <div className='row g-0'>
                 <div className='storyserials-main-heading'>Stories Serials</div>
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'} heading={"Three-in-One"} catId={1135} 
                 cards={ssrData.contentsOne} link={'/contents/three-in-one-1135.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'} heading={"My Dear Romeo"} catId={1053} 
                 cards={ssrData.contentsTwo} link={'/contents/mydearromeo-1053.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Silly Fellow"} catId={941}
                  cards={ssrData.contentsThree} link={'/contents/sillyfellow-941.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'}  title={'title'}  heading={"Hello Wrong Number"} catId={933} 
                 cards={ssrData.contentsFour} link={'/contents/hellowrongnumber-933.html'} />
                 </div> 

                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Taataadhithai Tadiginatom"} catId={758}
                  cards={ssrData.contentsFive} link={'/contents/taataadhithaitadiginatom-758.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                 <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'}  heading={"Aahanagar Colony"} catId={709}
                  cards={ssrData.contentsSix} link={'/contents/aahanagarcolony-709.html'} />
                 </div> 
                 <div className='col-md-6 col-12'>
                  <SectionSmall type={'comedyContentCategoryJson.php'} title={'title'} heading={"Gura Vayanam"} catId={29}
                   cards={ssrData.contentsOne} link={'/contents/audiojokes-669.html'} />
                 </div> 
     
                
            </div>         
               
                 <PageAds  mobile={mobile} containerRef={containerRef} />
             </div>     
        
      )
}

export default ComedyStoriesSerials;
